if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}
(function(){

	$(document).ready(function () {

 
        $(".location__toggle a").click(function(e) {
            e.preventDefault();
            $('.location__toggle a').removeClass('active');
            $(this).addClass('active');
            if($(this).hasClass('showDistance')) {
                $('.location__cat .distance').show();
                $('.location__cat .time').hide();
            } else {
                $('.location__cat .distance').hide();
                $('.location__cat .time').show();
            }
        });  
        $(".js-lightboxbtn").click(function(e) {
            e.preventDefault();
            let target = $(this).attr('href');
            $(target).fadeIn();
            $("body").addClass("noscroll"); 
            $('.lightbox__overlay').fadeIn();
            $('.lightbox__gallery').unslick();
            $('.lightbox__gallery').slick({
                arrows:false,
                slidesToShow:1,
                dots:true
            });
        }); 
        $(".js-lightboxclose").click(function(e) {
            e.preventDefault();
            $("body").removeClass("noscroll");
            $('.lightbox').fadeOut();
            $('.lightbox__overlay').fadeOut();
        }); 
        //$('.lightbox').hide();

        if($(window).width() < 767) {
            $('#rooms').slick({
                arrows:false,
                slidesToShow:1,
                dots:true
            });
        }
        $("div.select").click(function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
        });
        $("div.select__options span").click(function(e) {
            e.preventDefault();
            var $this_location = $(this).attr("data-location");
            var $this_value = $(this).html();
            console.log($this_value);
            $(this).parent('.select').removeClass('open');
            $(".select."+$this_location+" .select__active").html($this_value);
            $("#"+$this_location).val($this_value);
        });

        $('nav li a').click(function () {
            var target = $(this).attr("href");
            $('html, body').animate({scrollTop: $(target).offset().top - 10}, 1000);
            return false;
        });
        
        //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
        let DATE_STYLE = [true];
        function calendarRange(date){			
            let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn-d').val());		
            let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut-d').val());
            if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
                DATE_STYLE[1] = 'highlight-top';
            }else if(date > d1 && date < d2){
                DATE_STYLE[1] = 'highlight';
            }else{
                DATE_STYLE[1] = '';
            }
            return DATE_STYLE;
        }

        //Check in and check out datepicker for booking engine
        const DATE_FORMAT = "yy-mm-dd";		
        $( "#CheckIn-d" ).datepicker({
            changeMonth: true,
            numberOfMonths: 1,
            minDate: 0,
            onSelect: function( selectedDate ) {
                let getDate = $(this).datepicker('getDate');
                let newDate = new Date(getDate.getTime());
                newDate.setDate(newDate.getDate() + 3);
                $( "#CheckOut-d" ).datepicker( "setDate", newDate );
                $( "#CheckOut-d" ).datepicker( "option", "minDate", selectedDate );
            }
        });
        $( "#CheckOut-d" ).datepicker({
            changeMonth: true,
            numberOfMonths: 1
        });

	});

    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

}()); 